<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
    >
      <a-form-model-item
        label="选择新增固件"
        prop="versionIds"
      >
        <a-select
          show-search
          v-model="form.versionIds"
          placeholder="请选择"
          allow-clear
          mode="multiple"
          :filter-option="filterOption"
        >
          <a-select-option
            v-for="(item,key) in versionList"
            :key="key"
            :value="item.id"
          >{{ item.remark }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button
            type="primary"
            :loading="submitLoading"
            @click="submitForm"
          >
            保存
          </a-button>
          <a-button
            type="dashed"
            @click="cancel"
          >
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { edit } from '@/api/tram/customer'
import { listappVersion } from '@/api/system/version'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        customerId: null,
        versionIds: []
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        versionIds: [
          { required: true, message: '版本号不能为空', trigger: 'blur' }
        ]
      },
      versionList: []
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    getList () {
      listappVersion({ appType: 3 }).then(res => {
        this.versionList = res.data
        console.log(res, '版本列表')
      })
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        customerId: null,
        versionIds: []
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (id) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '绑定'
      this.form.customerId = id
      this.getList()
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          edit(this.form).then(response => {
            this.$message.success(
              '绑定成功',
              3
            )
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
